module.exports = __webpack_public_path__ + "static/img/8areaA_09.72a0afc.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/8areaA_09.png
// module id = 1063
// module chunks = 1